<template>
  <div class="pb-2">
    <ValidationObserver v-slot="{ handleSubmit }" ref="formTransferir">
      <b-form @submit.prevent="handleSubmit(confirmOferta)">
        <div>
          <PRow>
            <PCol md="12" lg="6">
              <div class="pl-2 pr-3">
                <detalle-demanda :ofertaDemanda="demanda" />
              </div>
            </PCol>
            <PCol md="12" lg="6">
              <div class="pl-3 pr-3">
                <div>
                  <b-card-title class="data-form pl-3 pt-4">
                    {{ $t("label.crear.transferencia") }}
                  </b-card-title>
                  <div>
                    <PRow>
                      <PCol v-if="clientes.length <= 1">
                        <PDataLine
                          class="mb-0"
                          :value="{
                            cliente: clienteSelected?.desCliente,
                          }"
                          :fields="{
                            cliente: { title: $t('label.cliente') },
                          }"
                        />
                      </PCol>
                      <PCol v-else>
                        <PFormSelect
                          v-model="ofertaParams.pkCliente"
                          :options="clientes"
                          optionValue="id"
                          optionText="desCliente"
                          :label="$t('label.cliente')"
                          :placeholder="$t('option.select')"
                          :rules="'required'"
                          @change="onSearchSaldoActuales"
                        />
                      </PCol>
                    </PRow>
                    <PRow>
                      <PCol v-if="delegaciones.length === 1">
                        <PDataLine
                          class="mb-0"
                          :value="{
                            delegacion: demanda.clientexdel.delegacion.desDelegacion,
                            divisa: divisa.simbolo + ' ' + divisa.codDivisa,
                          }"
                          :fields="{
                            delegacion: { title: $t('label.delegacion') },
                            divisa: { title: $t('label.divisa') },
                          }"
                          :showSeparators="true"
                        />
                      </PCol>
                      <PCol class="mt-1" v-else>
                        <PFormSelect
                          v-model="ofertaParams.pkDelegacion"
                          :options="delegaciones"
                          optionValue="id"
                          optionText="desDelegacion"
                          :label="$t('label.delegaciones')"
                          :placeholder="$t('option.select')"
                          :rules="'required'"
                          @change="onSearchSaldoActuales"
                        />
                      </PCol>
                    </PRow>
                    <PRow>
                      <PCol class="mt-1" md="6" v-if="clienteSelected?.pais.hasTransportadora">
                        <PFormSelect
                          v-model="ofertaParams.pkTransportadora"
                          :options="transportadoras"
                          optionValue="id"
                          optionText="descripcion"
                          :label="$t('label.transportadora.origen')"
                          :placeholder="$t('option.select')"
                          name="select_transportadora"
                          :rules="'required'"
                        />
                      </PCol>
                    </PRow>
                    <PRow class="mt-2" v-if="saldoActual">
                      <PCol>
                        <PDataLine
                          class="mb-0"
                          :value="{
                            saldoRestante: `${divisa.simbolo} ${filterNumber(
                              Number(saldoActual.saldoActual) - Number(saldoOfertar)
                            )}`,
                            totalOfertar: filterNumber(Number(saldoOfertar)),
                          }"
                          :fields="{
                            saldoRestante: { title: $t('label.saldo.restante') },
                            totalOfertar: { title: $t('label.total.ofertar') },
                          }"
                          :widthContent="true"
                          :showSeparators="true"
                        />
                      </PCol>
                    </PRow>
                    <PRow>
                      <PCol>
                        <PTableSimple :fields="fields_PTableSimple" :items="detallesSaldo">
                          <template #denominacion="{ item }">
                            {{ item.calidadDenominacion.denominacion.codDenominacion }}
                            {{ item.calidadDenominacion.desCalidad }}
                          </template>
                          <template
                            #saldoActual="{ item }"
                            v-if="clienteSelected && !clienteSelected.fakeCerts"
                          >
                            {{ divisa.simbolo }}
                            {{ filterNumber(item.saldoActual) }}
                          </template>
                          <template #calidadDenominacion="{ item, showExtend }">
                            <div
                              @click="showExtend"
                              class="denominacion-importe"
                              v-if="demanda.checkParcial"
                            >
                              {{ divisa.simbolo }}
                              {{ filterNumber(item.calidadDenominacion.importe, 2) }}
                            </div>
                            <div v-else>
                              {{ divisa.simbolo }}
                              {{ filterNumber(item.calidadDenominacion.importe) }}
                            </div>
                          </template>
                          <template #extend="{ item, index }">
                            <ValidationProvider
                              v-slot="{ errors }"
                              :rules="`required|min_value:0|valid-denomination:${item.calidadDenominacion.denominacion.numValue}`"
                              :name="`cantidad-denominacion_${index}`"
                              v-if="demanda.checkParcial"
                            >
                              <b-card class="input-card">
                                <b-card-body>
                                  <b-row>
                                    <b-col offset-lg="3" offset-md="3" lg="6" md="6">
                                      <b-form-group>
                                        <b-input
                                          type="number"
                                          min="0"
                                          :max="item.saldoMaximoOfertar"
                                          :step="item.calidadDenominacion.denominacion.numValue"
                                          v-model="item.calidadDenominacion.importe"
                                          :name="`cantidad-denominacion_${index}`"
                                          :id="`cantidad-denominacion_${index}`"
                                          :state="errors[0] ? false : null"
                                          :aria-describedby="`cantidad-denominacion-feedback_${index}`"
                                        />
                                      </b-form-group>
                                    </b-col>
                                  </b-row>
                                  <b-input
                                    type="range"
                                    min="0"
                                    :max="item.saldoMaximoOfertar"
                                    :step="item.calidadDenominacion.denominacion.numValue"
                                    v-model="item.calidadDenominacion.importe"
                                    class="mt-1"
                                  />
                                </b-card-body>
                              </b-card>

                              <b-form-invalid-feedback
                                :id="`cantidad-denominacion-feedback_${index}`"
                                class="d-block"
                              >
                                {{ errors[0] }}
                              </b-form-invalid-feedback>
                            </ValidationProvider>
                          </template>
                        </PTableSimple>
                      </PCol>
                    </PRow>
                    <PRow>
                      <PCol col="6" md="4">
                        <label class="label-form" for="coste">{{ $t("label.coste") }}</label>
                        <span class="data-form" id="coste">
                          {{ $t(`label.coste.${demanda.coste.codParametro}`) }}
                        </span>
                      </PCol>
                      <PCol col="6" md="4" v-if="demanda.clientexdel.cliente.pais.hasTasa">
                        <label class="label-form" for="tasa">{{ $t("label.tasa") }}</label>
                        <span
                          v-if="!demanda.clientexdel.cliente.pais.hasTasaEnteros"
                          class="data-form"
                          id="tasa"
                          >{{ filterNumber(demanda.numTasa, 5) }} %</span
                        >
                        <span
                          v-if="demanda.clientexdel.cliente.pais.hasTasaEnteros"
                          class="data-form"
                          id="tasa"
                        >
                          {{ Math.round(demanda.numTasa * 100000) }} x 10.000
                        </span>
                      </PCol>
                    </PRow>
                    <PRow>
                      <PCol col="6" v-if="clienteSelected?.pais.admiteAnonimo">
                        <PFormSwitch v-model="isAnonimo" :label="$t('label.oferta.anonima')" />
                      </PCol>
                    </PRow>
                    <PRow>
                      <PCol>
                        <label class="label-form mb-2" for="observacionesOferta">{{
                          $t("label.observaciones")
                        }}</label>
                        <textarea
                          class="textarea"
                          id="observacionesOferta"
                          v-model="observacionesOferta"
                          name="observacionesOferta"
                          type="text"
                        />
                      </PCol>
                    </PRow>
                  </div>
                </div>
              </div>
            </PCol>
          </PRow>
          <b-row class="mb-3 mt-5">
            <b-col class="text-center">
              <b-button
                pill
                variant="outline-primary"
                class="p-button-secondary mr-4"
                @click="cancelar"
                >{{ $t("label.cancelar") }}
              </b-button>
              <b-button
                pill
                variant="primary"
                class="p-button-primary ml-4"
                :disabled="!(saldoOfertar > 0)"
                type="submit"
                >{{ $t("label.transferir") }}
              </b-button>
            </b-col>
          </b-row>
        </div>
      </b-form>
    </ValidationObserver>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import {
  ICliente,
  IDelegacion,
  IDetalleDemanda,
  IDetallesSaldo,
  IDivisa,
  IOfertaDemanda,
  ISaldo,
  ITransportadora,
} from "@/entities";
import { Action, Getter } from "vuex-class";
import { IDetalleOfertaParams, IOfertaParams, ISaldoActualParams } from "@/services";
import { EventBus } from "@/event-bus";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import VueFilters from "@/vue-filters";
import DetalleDemanda from "@/pages/transferencias/common/OfertaDemandaDetalle.vue";
import { SweetAlertResult } from "sweetalert2";
import VueMethods from "@/vue-methods";

@Component({
  name: "transferir-modal",
  mixins: [VueFilters, VueMethods],
  components: {
    DetalleDemanda,
    ValidationObserver,
    ValidationProvider,
  },
})
export default class OfertarSobreDemanda extends Vue {
  @Prop({ required: true }) demanda!: IOfertaDemanda;
  @Prop({ required: true }) divisa!: IDivisa;
  @Getter("getClienteSelected") getClienteSelected!: ICliente;
  @Action("fetchSaldoActual") fetchSaldoActual!: (
    params?: ISaldoActualParams
  ) => Promise<ISaldo | undefined>;
  @Action("fetchClientesXDelegacion") fetchClientesXDelegacion!: (
    idDelegacion?: number
  ) => Promise<ICliente[] | undefined>;
  ofertaParams: IOfertaParams = {
    numCantidad: 0,
    coste: 0,
    pkDivisa: 0,
    pkCliente: 0,
    pkDelegacion: 0,
    pkTransportadora: null,
    detallesOferta: [],
    pkDelegaciones: [],
  };

  $refs!: {
    formTransferir: InstanceType<typeof ValidationObserver>;
  };

  public clientes: ICliente[] = [];
  public saldoActual: ISaldo | null = null;
  public transportadoras: ITransportadora[] | null = [];
  public detallesSaldo: IDetallesSaldo[] = [];
  public observacionesOferta: string | undefined = "";
  private isAnonimo = false;

  async mounted(): Promise<void> {
    await this.searchClientes(
      Number(this.demanda.clientexdel?.delegacion?.id),
      Number(this.divisa?.id)
    );
    this.demanda.detallesDemanda?.forEach((value) =>
      this.$set(
        value.soCalidadDenominacion,
        "importe",
        this.demanda.checkParcial ? 0 : value.cantidadDisponible
      )
    );

    this.ofertaParams.pkDelegacion = this.demanda.clientexdel?.delegacion?.id;
    this.ofertaParams.pkCliente =
      this.clientes.find((c) => c.id === this.getClienteSelected?.id)?.id ?? this.clientes[0].id!;

    this.onSearchSaldoActuales();
  }

  get clienteSelected(): ICliente | null {
    return this.clientes.find((cliente) => cliente.id === this.ofertaParams.pkCliente) || null;
  }

  get delegaciones(): IDelegacion[] {
    return (
      this.demanda.ubicaciones
        ?.map((ubicacion) => ubicacion.delegacion)
        .filter((delegacion) => delegacion.active)
        .sort((a, b) => this.sortAscending(a, b, "desDelegacion")) || []
    );
  }

  get fields_PTableSimple(): { key: string; label: string }[] {
    if (this.clienteSelected?.fakeCerts) {
      return [
        { key: "denominacion", label: this.$t("label.denominacion") },
        { key: "calidadDenominacion", label: this.$t("label.ofertado") },
      ];
    } else {
      return [
        { key: "denominacion", label: this.$t("label.denominacion") },
        { key: "saldoActual", label: this.$t("label.disponible") },
        { key: "calidadDenominacion", label: this.$t("label.ofertado") },
      ];
    }
  }

  async searchClientes(idDelegacion: number, idDivisa: number): Promise<void> {
    const res =
      (await this.$services.clientes._fetchAllClienteXDelegacionAndDivisa(
        idDelegacion,
        idDivisa
      )) || [];
    if (res) {
      this.clientes = res.filter(
        (cliente) => cliente.id != this.demanda.clientexdel?.cliente?.id && cliente.active
      );
    } else {
      EventBus.$emit("p-toast", { variant: "danger", message: res });
    }
  }

  async searchTransportadoras(): Promise<void> {
    if (this.clienteSelected) {
      const res = await this.$services.transportadoras.fetchAllTransportadorasByCodPaisCorto(
        this.clienteSelected.pais.codPaisCorto
      );
      if (res) {
        this.transportadoras = res;
      }
    }
  }

  pushDetalleSaldo(
    detalleSaldo: IDetallesSaldo | undefined,
    detalleDemanda: IDetalleDemanda
  ): void {
    if (detalleSaldo) {
      if (this.demanda?.checkParcial) {
        this.$set(detalleSaldo.calidadDenominacion!, "importe", 0);
        detalleSaldo.saldoMaximoOfertar =
          detalleDemanda.cantidadDisponible > detalleSaldo.saldoActual!
            ? detalleSaldo.saldoActual
            : detalleDemanda.cantidadDisponible;
      } else {
        this.$set(detalleSaldo.calidadDenominacion!, "importe", detalleDemanda.cantidadDisponible);
      }
      this.detallesSaldo.push(detalleSaldo);
    }
  }

  cancelar(): void {
    this.$emit("cancel");
    this.ofertaParams.pkDemanda = undefined;
  }

  get saldoOfertar(): number {
    let sumaImportes = 0;
    this.detallesSaldo?.forEach((detalleSaldo) => {
      if (detalleSaldo.calidadDenominacion?.importe) {
        sumaImportes = Number(sumaImportes) + Number(detalleSaldo.calidadDenominacion?.importe);
      }
    });

    return sumaImportes;
  }

  onSearchSaldoActuales(): void {
    this.saldoActual = null;
    this.detallesSaldo = [];

    if (this.clienteSelected && this.ofertaParams.pkDelegacion && this.divisa) {
      this.searchSaldosActuales(this.divisa);
    }
  }

  async searchSaldosActuales(divisa: IDivisa): Promise<void> {
    if (!this.clienteSelected?.fakeCerts) {
      const res = await this.fetchSaldoActual({
        pkCliente: this.ofertaParams.pkCliente,
        pkDelegacion: this.ofertaParams.pkDelegacion,
        pkDivisa: divisa.id,
      });
      if (res) {
        this.saldoActual = res;
        this.demanda?.detallesDemanda?.forEach((detalleDemanda) => {
          const detalleSaldo = this.saldoActual?.detallesSaldo?.find(
            (detalle) =>
              detalle.calidadDenominacion?.id === detalleDemanda.soCalidadDenominacion?.id &&
              (detalle.saldoActual! >= detalleDemanda.cantidadDisponible ||
                this.demanda.checkParcial)
          );
          this.pushDetalleSaldo(detalleSaldo, detalleDemanda);
        });
      } else {
        EventBus.$emit("p-toast", { variant: "danger", message: res });
      }
    } else {
      this.demanda?.detallesDemanda?.forEach((detalleDemanda) => {
        const detalleSaldo = {
          calidadDenominacion: {
            denominacion: detalleDemanda.soCalidadDenominacion.denominacion,
            codCalidad: detalleDemanda.soCalidadDenominacion.codCalidad,
            desCalidad: detalleDemanda.soCalidadDenominacion.desCalidad,
            importe: 0,
            id: detalleDemanda.soCalidadDenominacion.id,
            cantidad: 0,
            importeSelected: false,
            cantidadSelected: false,
          },
          saldoActual: detalleDemanda.cantidadDisponible,
          saldoMaximoOfertar: detalleDemanda.cantidadDisponible,
        };
        this.pushDetalleSaldo(detalleSaldo, detalleDemanda);
      });
    }
    if (this.clienteSelected?.pais.hasTransportadora) {
      await this.searchTransportadoras();
    }
  }

  async confirmOferta(): Promise<void> {
    const res = await this.confirmTransferencia();
    if (res.isConfirmed) {
      await this.ofertar();
    }
  }

  async confirmTransferencia(): Promise<SweetAlertResult> {
    return this.$swal({
      title: this.$t("label.confirmar"),
      text: this.$t("label.transferencias.disclaimer"),
      icon: "question",
      showCancelButton: true,
      confirmButtonText: this.$t("label.yes"),
      cancelButtonText: this.$t("label.no"),
    });
  }

  async ofertar(): Promise<void> {
    const detallesOferta: IDetalleOfertaParams[] = [];

    this.detallesSaldo?.forEach((detalle) => {
      if (detalle.calidadDenominacion && detalle.calidadDenominacion.importe > 0) {
        detallesOferta.push({
          numCantidad: detalle.calidadDenominacion?.importe,
          calidadDenominacion: detalle.calidadDenominacion,
        });
      }
    });

    if (this.clienteSelected) {
      this.ofertaParams.numCantidad = this.saldoOfertar;
      this.ofertaParams.coste = this.demanda.coste.id;
      this.ofertaParams.pkDivisa = this.divisa.id;
      this.ofertaParams.detallesOferta = detallesOferta;
      this.ofertaParams.numTasa = this.clienteSelected.pais.hasTasa
        ? Number(this.demanda?.numTasa)
        : undefined;
      this.ofertaParams.pkDemanda = this.demanda?.id;
      this.ofertaParams.observacionesOferta = this.observacionesOferta;
      this.ofertaParams.checkAnonimo = this.isAnonimo;
      this.$emit("action", { action: "ofertarSobreDemandaConfirmed", data: this.ofertaParams });
    } else {
      EventBus.$emit("p-toast", { variant: "danger", message: "No hay cliente selecionado" });
    }
  }
}
</script>

<style lang="scss" scoped>
.label-form {
  font-size: 12px;
  line-height: 16px;
  font-weight: normal;
  color: var(--secundario-prosegur-oscuro-plus-10);
  margin-bottom: 0;
}

.denominacion-importe {
  color: var(--amarillo-prosegur);
  cursor: pointer;
}
.input-card {
  margin: 1rem 0;
  padding: 1rem;
  border-radius: 6px;
  border: solid 0.7px #f1f0f0;
  background-color: rgba(255, 209, 2, 0.04);
}
.textError {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;
}
.buttons_DemandarSobreOferta {
  display: flex;
  justify-content: center;
}
.textarea {
  height: 100px;
  width: 100%;
  border-radius: 6px;
  border: solid 1px #ced4da;
}
.data-form {
  font-size: 14px;
  font-weight: bold;
  line-height: 16px;
  color: var(--secundario-prosegur-claro);
  text-transform: initial;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  width: 99%;
  overflow: hidden;
}
</style>
